import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('vision_benefits_set_review', '/vision_benefits_set_reviews', 'review')
const actions = generator.generate()

export default actions
